export enum SeriesSegmentType {
  audio = 'audio',
  image = 'image',
  questionnaire = 'questionnaire',
  video = 'video',
  text = 'text',
}
